<template>
    <div class="users_filter">
        <b-modal id="users_filter"
                 v-bind:no-close-on-backdrop=true
                 :hide-header=true
                 v-model="show"
                 size="xl"
                 bodyClass="p-0"
                 title="Редагувати погодження"
        >
            
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2>
                    Редагувати <span class="fw-300">погодження</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show">
                <div class="panel-content p-2">
                    <b-row>
                        <b-col sm="6" class="adjusted_list " v-if="!is_recipient_edit">
                            <draggable class="adj_move u_list" v-model="added" v-if="added.length > 0"  v-bind="dragOptions('before')">
                                <user_block
                                    :show_vacation="true"
                                    v-for="(item,idx) in added"
                                    :key="item.id"
                                    v-bind:can_del=true
                                    v-bind:del_triger="remove_adjust_from_doc"
                                    v-bind:user="item">
                                </user_block>
                            </draggable>
                            
                            <div class="user_list u_list" v-if="this.adjust.length > 0">
                                <div class="isp_list" >
                                    <user_block v-for="(item) in this.adjust" :key="item.id" v-bind:user="item"></user_block>
                                </div>
                            </div>
                            
                            <draggable class="adj_move u_list" v-model="added_after" v-if="added_after.length > 0"  v-bind="dragOptions('after')">
                                <user_block
                                    :show_vacation="true"
                                    v-for="(item,idx) in added_after"
                                    :key="item.id"
                                    v-bind:can_del=true
                                    v-bind:del_triger="remove_adjust_from_doc_after"
                                    v-bind:user="item">
                                </user_block>
                            </draggable>
                        
                        </b-col>
                        
                        <b-col sm="6" class="adjusted_list " v-if="is_recipient_edit">
                            
                            <div class="user_list u_list" v-if="this.all_adjust.length > 0">
                                
                                <div class="isp_list" >
                                    <user_block v-for="(item) in this.all_adjust" :key="item.id" v-bind:user="item"></user_block>
                                </div>
                                
                                <draggable class="adj_move u_list" v-model="recipient_added" v-if="recipient_added.length > 0"  v-bind="dragOptions('recipient')">
                                    <user_block
                                        :show_vacation="true"
                                        v-for="(item,idx) in recipient_added"
                                        :key="item.id"
                                        v-bind:can_del=true
                                        v-bind:del_triger="remove_adjust_from_doc_after"
                                        v-bind:user="item">
                                    </user_block>
                                </draggable>
                            </div>
                        
                        </b-col>
                        
                        <b-col sm="6">
                            <div class="search_form">
                                <div class="search_filed">
                                    
                                    <b-input-group>
                                        <b-input-group-text slot="prepend" >по ПІБ, посада</b-input-group-text>
                                        <b-form-input v-model="search"></b-form-input>
                                    </b-input-group>
                                    
                                    <div class="users_list pt-3 ml-0 pl-0">
                                        <ul class="user_list_to_insert ml-0 pl-0">
                                            <li v-for="(item) in searched"  :class="user_class(item,'before')" >
                                                <div class="user_profile position-relative border mb-2" >
                                                    <div class="d-flex flex-row pt-2 pl-2 pb-2" >
                                                     <span class="status " >
                                                            <span class="profile-image rounded-circle d-inline-block " v-bind:style="{
                                                                      'background-image': 'url(' + item.medium_img + ')',
                                                                      'background-size': 'cover'
                                                                }"
                                                            ></span>
                                                     </span>
                                                        <!-- profile photo end -->
                                                        <div class="ml-3">
                                                            <div class="user_attrib">
                                                                <div class="name d-block fw-700 text-dark" v-text=item.name></div>
                                                                <div class="company small text-dark" v-text=user_company(item)></div>
                                                                <div class="dolznost small text-dark" v-text=item.dolznost></div>
                                                                
                                                                <div class="vacation">
                                                                    <vacation :id=parseInt(item.id)></vacation>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="add_adjust" v-if="!is_recipient_edit">
                                                            <div class="add_in_start cursor-pointer bg-warning-500 shadow text-white"  @click.prevent="set_active(item,'before')">
                                                                В початок
                                                            </div>
                                                            <div class="add_in_end cursor-pointer bg-warning-500 shadow text-white" v-if="can_show_after" @click.prevent="set_active(item,'after')">
                                                                В кінець
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="add_adjust" v-else>
                                                            <div class="add_in_end add_in_end_rec cursor-pointer bg-warning-500 shadow text-white text-center"
                                                                 @click.prevent="set_active(item,'recipient')">
                                                                Перед погодженням
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                </div>
                                            
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            
            <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-spinner variant="success" v-if="show_action"></b-spinner>
                
                <b-button size="xl" variant="outline-primary" @click.prevent="close_filter()"  class="btn btn-lg  waves-effect waves-themed mr-3">
                    <i class="fal fa-check mr-1"></i>
                    Зберегти
                </b-button>
            
            
            
            </template>
        </b-modal>
    </div>
</template>

<script>

import draggable from 'vuedraggable'
import user_block from "../../../../../shared/user/user_block/user_block.vue";
import vacation from "../../../../../shared/user/user_block/vacation.vue";

export default {
    name: "adjust_editor",
    components : {
        user_block,
        draggable,
        vacation
    },
    
    data() {
        return  {
            show : false,
            show_action : false,
            uniq_call : '',
            current_type : "standart_edit",
            
            remove_adjust_from_doc : 'remove_user_from_editor',
            remove_adjust_from_doc_after : 'remove_user_from_editor_after',
            remove_adjust_from_recipient : 'remove_adjust_from_recipient',
            
            doc_id : 0,
            search : '',
            search_after : '',
            adjust : [],
            
            added  : [],
            added_after  : [],
            
            recipient_added : [],
            
            searched : [],
            searched_after : [],
            
            dir:{},
            form : {
                search : '',
                cur_type : 'search'
            },
            
        }
    },
    
    created() {
        
        EventBus.$on('remove_dir_editor', e => {
            this.dir = null;
        });
        
        EventBus.$on('remove_user_from_editor', e => {
            this.remove_user(e,'before');
        });
        
        EventBus.$on('remove_user_from_editor_after', e => {
            this.remove_user(e,'after');
        });
        
        EventBus.$on('remove_adjust_from_recipient', e => {
            this.remove_user(e,'recipient');
        });
        
        
        //  EventBus.$off('check_list');
        EventBus.$on('load_users_adjust', e => {
            if(e !== undefined) {
                this.doc_id = e.doc_id;
                if(e.hasOwnProperty("cur_type")) {
                    this.current_type = e.cur_type;
                }
                
                this.load_adjust();
            }
            this.show = true;
        });
    },
    
    computed : {
        can_show_after () {
            console.log('check_if can display');
            
            if(this.adjust != undefined && this.adjust.length > 0) {
                return true;
            }
            
            return false;
        },
        is_recipient_edit() {
            return this.current_type !== "standart_edit";
        },
        
        all_adjust() {
            let full_list = [];
            
            this.added.map(item => {
                full_list.push(item);
            });
            
            this.adjust.map(item => {
                full_list.push(item);
            });
            
            this.added_after.map(item => {
                full_list.push(item);
            });
            
            return full_list;
            
        },
    },
    
    methods : {
        
        close() {
            this.show = false;
        },
        
        dragOptions(type) {
            return {
                animation: 200,
                group: "description" + type,
                disabled: false,
                ghostClass: "ghost"
            };
        },
        send_form (search) {
            this.form.search = search;
            return this.form;
        },
        
        
        close_filter () {
            this.show_action = true;
            
            if(!this.is_recipient_edit) {
                this.try_save(res => {
                    setTimeout(() => {
                        this.show_action = false
                        this.show = false;
                    }, 500);
                })
            }
            else {
                this.try_save_recipient(res => {
                    setTimeout(() => {
                        this.show_action = false
                        this.show = false;
                    }, 500);
                })
            }
        },
        
        set_active (item,type) {
            if(this.is_excluded(item,type)) {
                return;
            }
            
            else {
                
                if(type == 'before') {
                    this.added.push(item);
                }
                
                if(type == 'after') {
                    this.added_after.push(item);
                }
                
                if(type == 'recipient') {
                    this.recipient_added.push(item);
                }
                
            }
        },
        
        remove_user (user,type) {
            
            if (type == 'before') {
                for (let i = this.added.length - 1; i >= 0; i -= 1) {
                    if (this.added[i].id === user.id) {
                        this.added.splice(i, 1);
                    }
                }
            }
            
            if (type == 'recipient') {
                for (let i = this.recipient_added.length - 1; i >= 0; i -= 1) {
                    if (this.recipient_added[i].id === user.id) {
                        this.recipient_added.splice(i, 1);
                    }
                }
            }
            
            if (type == 'after') {
                for (let i = this.added_after.length - 1; i >= 0; i -= 1) {
                    if (this.added_after[i].id === user.id) {
                        this.added_after.splice(i, 1);
                    }
                }
            }
        },
        
        user_class(item,type) {
            
            if(this.is_excluded(item,type)){
                return 'disabled';
            }
            
        },
        
        is_excluded (item,type) {
            
            if (this.adjust.length > 0) {
                for (let i = this.adjust.length - 1; i >= 0; i -= 1) {
                    if (this.adjust[i].id === item.id) {
                        return true;
                    }
                }
            }
            
            if (this.added.length > 0) {
                
                for (let i = this.added.length - 1; i >= 0; i -= 1) {
                    if (this.added[i].id === item.id) {
                        return true;
                    }
                }
            }
            
            if (this.added_after.length > 0) {
                
                for (let i = this.added_after.length - 1; i >= 0; i -= 1) {
                    if (this.added_after[i].id === item.id) {
                        return true;
                    }
                }
            }
            
            if (this.recipient_added.length > 0) {
                
                for (let i = this.recipient_added.length - 1; i >= 0; i -= 1) {
                    if (this.recipient_added[i].id === item.id) {
                        return true;
                    }
                }
            }
            
            return false;
        },
        
        user_company (item) {
            if(this.obj_to_null(item) != null) {
                return item.company + ", " + item.department
            }
            //17500+4500
        },
        
        async load_users_search(srch,type) {
            if (srch.length > 2) {
                await api.post('/users', this.send_form(srch)).then(({data}) => {
                    if (data.status === "operation_success") {
                        if(type == 'standart') {
                            this.searched = data.data;
                        }
                        if(type == 'after') {
                            this.searched_after = data.data;
                        }
                    }
                }).catch(err => {
                    console.log(err);
                    this.is_load = false;
                });
            }
        },
        
        async load_adjust() {
            await api.get('/memorandums/' + this.doc_id + "/adjusts").then(({data}) => {
                if (data.status === "operation_success") {
                    this.adjust = data.data.standart;
                    this.added  = data.data.editable;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async try_save_recipient(callback) {
            await api.put('/memorandums/' + this.doc_id + "/recipient/adjusts", {
                    'users' : this.recipient_added,
                }
            ).then(({data}) => {
                window.location.href = "/inbox";
                this.after_save_action(data,callback)
            }).catch(err => {
                callback('err');
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async try_save(callback) {
            await api.put('/memorandums/' + this.doc_id + "/adjusts", {
                    'default'        : this.adjust,
                    'adjust_before'  : this.added,
                    'adjust_after'   : this.added_after,
                    'dir': this.dir
                }
            ).then(({data}) => {
               this.after_save_action(data,callback)
            }).catch(err => {
                callback('err');
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        after_save_action(data,callback) {
            if (data.status === "operation_success") {
                EventBus.$emit('refresh_tabs', {
                    tabs: [
                        'tab_monitoring',
                        'tab_resolution',
                        'tab_files',
                        'tab_work'
                    ]
                });
                callback('OK');
            }
        }
        
    },
    
    watch: {
        
        'search': function () {
            console.log('addon_change', this.search);
            if(this.search.length > 2) {
                this.load_users_search(this.search,'standart');
            }
            else {
                this.searched =[];
            }
        },
        
        'search_after': function () {
            console.log('addon_change', this.search_after);
            if(this.search_after.length > 2) {
                this.load_users_search(this.search_after,'after');
            }
            else {
                this.searched_after =[];
            }
        },
        
        
    }
}
</script>

<style scoped>
.add_in_start {
    position: absolute;
    top: 5px;
    right: 13px;
}

.add_in_end{
    position: absolute;
    bottom: 5px;
    right: 13px;
}

.add_in_end,
.add_in_start {
    padding: 2px;
    width: 100px;
    text-align: center;
}




.user_list_to_insert li {
    width: 100%;
}
#users_filter .search_filed {
    padding: 0;
    margin-left: 0;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}

.adj_move {
    cursor: move;
}

.u_list {
    box-shadow: 0 1px 2px #999;
    margin-bottom: 10px;
    border-top: 8px solid #eee;
    position: relative;
}

.u_list .user_profile {
    border-top:1px solid #eee;
    padding-top: 2px;
    padding-bottom: 2px;
}

.add_in_end_rec {
    width:170px;
}

ul.user_list_to_insert {
    margin-left: 0;
    width: 100%;
    float: left;
    max-height: 311px;
    overflow-y: auto;
}

</style>
